module.exports = __webpack_public_path__ + "static/media/pharmacore team.2b52164b.png";